<template>
    <div class="home pure-g">
    
        <StocktakingMenu :url="url"  class="pure-u-1-6"/>

        <div class="pure-u-5-6">

            <div class="formBox">
                <form  id="myStatisticFormBox" class="pure-form pure-form-stacked">
                    <fieldset>
                        <legend>Statistik</legend>

                        <div class="pure-g">

                        </div>
                    </fieldset>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import StocktakingMenu from '@/components/StocktakingMenu'
import Datepicker from 'vuejs-datepicker'
import axios from "axios"
import router from '@/router.js'
import { getJwt } from '@/utils/auth.js'
import { toastInfo, toastError } from '@/utils/toast.js'
import { getApiUrl } from '@/utils/api.js'

export default {
    name: 'StocktakingStatisticView',
    components: {
        StocktakingMenu,
        Datepicker
    },
    data: function() {
        return {
            url: null,
            date: null,
            store: null,
            modules: [],
            selectedModule: null
        }
    },
    created: function() {

        this.url = this.$route.params.url
    },
    mounted: function() {

        this.loadData(this.$route.params.url)
    },
    methods: {

        loadData: function(url) {

            axios({
                method: "GET",
                url: getApiUrl() + "/v0/modules?type=stocktaking",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {

                    this.modules = result.data.data
                    console.log(this.modules)
                },
                error => {
                    toastError(error.response.data.message);
                }
            )

            axios({
                method: "GET",
                url: url,
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + getJwt()
                }
            }).then(
                result => {
                    this.store = result.data.store
                    this.date = result.data.date
                    this.selectedModule = result.data._links.module.href
                },
                error => {
                    console.error(error.response.data.status)
                })
        },

        save: function() {

            console.log(this.selectedModule)

            axios({
                method: "PUT",
                url: this.$route.params.url,
                headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + getJwt()
                },
                data: {
                    date: this.date,
                    store: this.store
                }
            }).then(
                result => {
                toastInfo("Inventur wurde gespeichert.");

                router.push({ name: "stocktakingView" });

                },
                error => {
                    toastError(error.response.data.message);
                }
            )
        }
    }
}
</script>

<style>

#date {
    background-color: white;
}

#datePicker {
    background-color: white; 
}

#myStatisticFormBox {
    margin-top: 55px;
}
</style>
